import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-count-list-page',
  templateUrl: './count-list-page.component.html',
  styleUrls: ['./count-list-page.component.scss'],
})
export class CountListPageComponent implements OnInit {
  countType: string;
  status: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.countType = params.get('countType') as string;
      this.status = params.get('status') as string;
    });
  }
}
